import { UnderlyingHistoModal } from 'components/shared/UnderlyingHistos/UnderlyingHistoModal';
import type { UnderlyingHistorics } from 'components/shared/UnderlyingHistos/UnderlyingHistoModels';
import { connect } from 'react-redux';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';
import { underlyingHistoRequested } from 'state/underlyingHistograph/underlyingHisto.action';
import {
  getUnderlyingHistoError,
  getUnderlyingHistorics,
  isUnderlyingHistographFetching,
  isUnderlyingHistographFetchingFailed,
} from 'state/underlyingHistograph/underlyingHisto.selector';

export interface UnderlyingHistoProps {
  isFetching: boolean;
  isFetchingFailed: boolean;
  underlyingsHistorics: UnderlyingHistorics;
  errorMessage?: string;
}

export interface UnderlyingHistoDispatchProps {
  onUnderlyingHistoModalClicked: (bloombergIds: string[]) => void;
}

export const mapStateToProps = (state: AppState): UnderlyingHistoProps => {
  return {
    isFetching: isUnderlyingHistographFetching(state),
    isFetchingFailed: isUnderlyingHistographFetchingFailed(state),
    underlyingsHistorics: getUnderlyingHistorics(state),
    errorMessage: getUnderlyingHistoError(state),
  };
};

export const mapDispatchToProps = (dispatch: ThunkDispatch): UnderlyingHistoDispatchProps => {
  return {
    onUnderlyingHistoModalClicked(bloombergIds) {
      dispatch(underlyingHistoRequested(bloombergIds));
    },
  };
};

export const UnderlyingHistoModalConnected = connect(mapStateToProps, mapDispatchToProps)(UnderlyingHistoModal);
